import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";
import { TickIcon } from "resources/svg-images/TickIcon";
import HideIf from "util/HideIf";
import styles from "./product-filter-sort.module.scss";
import { sortNameConstant } from "./sortNameConstant";

const propTypes = {
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
export default function ProductFilterSortBy(props: any) {
  const { value, onClick, className = "" } = props;
  const { t } = useTranslation("category");

  const options = [{ label: sortNameConstant.relevance, value: "relevance" },
    { label: sortNameConstant.highToLow, value: t("highToLow") },
    { label: sortNameConstant.lowToHigh, value: t("lowToHigh") }];

  // function getLabelByValue(val: string) {
  //   const option = options.find((op) => op.value === val);
  //   return option ? option.label : "";
  // }

  return (
    <div className={styles.sort_container}>
      {options.map((option) => (
        <button
          className={`${styles.sort_btn} ${value === option.value ? styles.selected_sort : ""} ${className}`}
          onClick={() => onClick(option.value)}
          key={option.value}
          type="button"
        >
          {option.label}
          <HideIf show={value === option.value}>
            <TickIcon />
          </HideIf>
        </button>
      ))}
    </div>
  );

  // return (
  //   <div className={`d-flex ${className}`}>
  //     <div className={`d-flex align-items-center m-l-5 ${styles.sort_by_dropdown}`}>
  //       <div className={styles.dropdown_styles}>
  //         <Select
  //           // className="form-control"
  //           instanceId={value}
  //           value={{ label: getLabelByValue(value), value }}
  //           isSearchable={false}
  //           isClearable={false}
  //           onChange={(selected: any) => onChange(selected.value)}
  //           options={options}
  //           classNamePrefix="react-select"
  //           styles={{
  //             indicatorSeparator: (base) => ({
  //               ...base, display: "none",
  //             }),
  //             menu: (base) => ({
  //               ...base,
  //               zIndex: 51,
  //               marginTop: 0,
  //             }),
  //           }}
  //         />
  //       </div>
  //     </div>
  //   </div>
  // );
}

ProductFilterSortBy.propTypes = propTypes;
